import { render, staticRenderFns } from "./postalCodeFormInput.vue?vue&type=template&id=5977048d&"
import script from "./postalCodeFormInput.vue?vue&type=script&lang=js&"
export * from "./postalCodeFormInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports